module.exports = __webpack_public_path__ + "static/media/credit-card.310b1c33.svg";